import { Component } from '@angular/core';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';

@Component({
  selector: 'tf-block-ui',
  templateUrl: './tf-block-ui.component.html',
  styleUrls: ['./tf-block-ui.component.scss']
})
export class TfBlockUiComponent {

    fillColor = '#e71316';

    constructor(
        private productSiteRegionService: ProductSiteRegionService,
    ) {

        if (this.productSiteRegionService.isFisherSci()) {
            this.fillColor = '#0071bc';
        }

    }

}
